import "./exhaust.css";
import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import FadeInSection from "../FadeInup/FadeInup";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Helmet } from 'react-helmet';
import ReactPlayer from 'react-player'
import ProductCarousel from "../Product/productCarousel";
import ProductFaq from "../Product/productFaq";

const ExhaustHead = () => {

    const [metaData, setMetaData] = useState({
        urlSlug: '',
        titleTag: '',
        metaDescription: '',
        markupName: '',
        jsonLdMarkup: '',
        ogTitle: '',
        ogDescription: '',
        ogImage: '',
    });
    const [jsonData, setJsonData] = useState(null);

    const fetchSeoData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/seo-settings/exhaustseo007`);
            if (response.ok) {
                const result = await response.json();
                const data = result.data;
                setMetaData({
                    urlSlug: data.urlSlug || '',
                    titleTag: data.titleTag || '',
                    metaDescription: data.metaDescription || '',
                    markupName: data.markupName || '',
                    jsonLdMarkup: data.jsonLdMarkup || '',
                    ogTitle: data.ogTitle || '',
                    ogDescription: data.ogDescription || '',
                    ogImage: data.ogImage || '',
                });
                const jsonObjects = JSON.parse(`[${data.jsonLdMarkup}]`);

                setJsonData(jsonObjects);
            }
        } catch (error) {

        }

    };

    useEffect(() => {
        fetchSeoData();
    }, [])
    return (
        <>
            <Helmet>
                {/* Dynamically setting title, meta, and Open Graph tags */}
                <title>{metaData.titleTag}</title>
                <meta name="description" content={metaData.metaDescription} />
                <link rel="canonical" href={metaData.urlSlug} />
                <meta property="og:title" content={metaData.ogTitle} />
                <meta property="og:site_name" content="Colorbot" />
                <meta property="og:url" content={metaData.urlSlug} />
                <meta property="og:description" content={metaData.ogDescription} />
                <meta property="og:type" content="website" />

                {/* Dynamically include JSON-LD markup */}
                {jsonData && jsonData.map((data, index) => (

                    <script type="application/ld+json" key={index}>
                        {JSON.stringify(data)}
                    </script>
                ))}
            </Helmet>
        </>)
};

function Exhaust() {
    useEffect(() => {
        window.scrollTo(0, 0);


    }, []);




    const [exhaustecoz150, setexhaustecoz150] = useState([
        {
            value: "Charcoal black",
            color: "#000000",
            secondary: "#000000",
            available: false
        }, {
            value: "Artic white",
            color: "#d8d8d8",
            secondary: "#d8d8d8",
            available: false
        }, {
            value: "Ash grey",
            color: "#6d6d6d",
            secondary: "#6d6d6d",
            available: false
        }, {
            value: "Classic Maroon",
            color: "#830B00",
            secondary: "#830B00",
            available: false
        },
        {
            value: "Noir white",
            color: "#F0F0F0",
            secondary: "#000000",
            available: false
        }
    ])
    const [exhausturbo150, setexhausturbo150] = useState([
        {
            value: "Charcoal black",
            color: "#000000",
            secondary: "#000000",
            available: false
        }, {
            value: "Artic white",
            color: "#d8d8d8",
            secondary: "#d8d8d8",
            available: false
        }, {
            value: "Ash grey",
            color: "#6d6d6d",
            secondary: "#6d6d6d",
            available: false
        }, {
            value: "Classic Maroon",
            color: "#830B00",
            secondary: "#830B00",
            available: false
        },
        {
            value: "Noir white",
            color: "#F0F0F0",
            secondary: "#000000",
            available: false
        }
    ])
    const [exhaustecoz200, setexhaustecoz200] = useState([
        {
            value: "Charcoal black",
            color: "#000000",
            secondary: "#000000",
            available: false
        }, {
            value: "Artic white",
            color: "#d8d8d8",
            secondary: "#d8d8d8",
            available: false
        }, {
            value: "Ash grey",
            color: "#6d6d6d",
            secondary: "#6d6d6d",
            available: false
        }, {
            value: "Classic Maroon",
            color: "#830B00",
            secondary: "#830B00",
            available: false
        },
        {
            value: "Noir white",
            color: "#F0F0F0",
            secondary: "#000000",
            available: false
        }
    ])
    const [exhausturbo200, setexhausturbo200] = useState([
        {
            value: "Charcoal black",
            color: "#000000",
            secondary: "#000000",
            available: false
        }, {
            value: "Artic white",
            color: "#d8d8d8",
            secondary: "#d8d8d8",
            available: false
        }, {
            value: "Ash grey",
            color: "#6d6d6d",
            secondary: "#6d6d6d",
            available: false
        }, {
            value: "Classic Maroon",
            color: "#830B00",
            secondary: "#830B00",
            available: false
        },
        {
            value: "Noir white",
            color: "#F0F0F0",
            secondary: "#000000",
            available: false
        }
    ])
    const [exhaustecoz250, setexhaustecoz250] = useState([
        {
            value: "Charcoal black",
            color: "#000000",
            secondary: "#000000",
            available: false
        }, {
            value: "Artic white",
            color: "#d8d8d8",
            secondary: "#d8d8d8",
            available: false
        }, {
            value: "Ash grey",
            color: "#6d6d6d",
            secondary: "#6d6d6d",
            available: false
        }, {
            value: "Classic Maroon",
            color: "#830B00",
            secondary: "#830B00",
            available: false
        },
        {
            value: "Noir white",
            color: "#F0F0F0",
            secondary: "#000000",
            available: false
        }
    ])
    const [exhausturbo250, setexhausturbo250] = useState([
        {
            value: "Charcoal black",
            color: "#000000",
            secondary: "#000000",
            available: false
        }, {
            value: "Artic white",
            color: "#d8d8d8",
            secondary: "#d8d8d8",
            available: false
        }, {
            value: "Ash grey",
            color: "#6d6d6d",
            secondary: "#6d6d6d",
            available: false
        }, {
            value: "Classic Maroon",
            color: "#830B00",
            secondary: "#830B00",
            available: false
        },
        {
            value: "Noir white",
            color: "#F0F0F0",
            secondary: "#000000",
            available: false
        }
    ])

    const [exhaustactiveecoz150, setexhaustactiveecoz150] = useState("")
    const [exhaustactiveecoz200, setexhaustactiveecoz200] = useState("")
    const [exhaustactiveecoz250, setexhaustactiveecoz250] = useState("")
    const [exhaustactiveturbo150, setexhaustactiveturbo150] = useState("")
    const [exhaustactiveturbo200, setexhaustactiveturbo200] = useState("")
    const [exhaustactiveturbo250, setexhaustactiveturbo250] = useState("")
    const [exhaustFanDataEcoz150, setExhaustFanDataEcoz150] = useState([]);
    const [exhaustFanDataEcoz200, setExhaustFanDataEcoz200] = useState([]);
    const [exhaustFanDataEcoz250, setExhaustFanDataEcoz250] = useState([]);
    const [exhaustFanDataTurbo150, setExhaustFanDataTurbo150] = useState([]);
    const [exhaustFanDataTurbo200, setExhaustFanDataTurbo200] = useState([]);
    const [exhaustFanDataTurbo250, setExhaustFanDataTurbo250] = useState([]);


    const getproduct = async () => {
        try {
            await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetExhaustProduct`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },

            }).then((res) => res.json()).then((response) => {
                if (response.status === 200) {


                    const ecoz150 = response.data.filter((item) => item.ProductSize === "150mm" && item.ProductCategory === "ecoz");
                    for (let i = 0; i < ecoz150.length; i++) {
                        for (let j = 0; j < exhaustecoz150.length; j++) {
                            if (ecoz150[i].ProductColorCode === exhaustecoz150[j].color) {
                                exhaustecoz150[j].available = true;
                            }
                        }
                    }
                    setexhaustactiveecoz150(ecoz150[0]);

                    setExhaustFanDataEcoz150(ecoz150);


                    const ecoz200 = response.data.filter((item) => item.ProductSize === "200mm" && item.ProductCategory === "ecoz");
                    for (let i = 0; i < ecoz200.length; i++) {
                        for (let j = 0; j < exhaustecoz200.length; j++) {
                            if (ecoz200[i].ProductColorCode === exhaustecoz200[j].color) {
                                exhaustecoz200[j].available = true;
                            }
                        }
                    }
                    setexhaustactiveecoz200(ecoz200[0]);
                    setExhaustFanDataEcoz200(ecoz200);

                    const ecoz250 = response.data.filter((item) => item.ProductSize === "250mm" && item.ProductCategory === "ecoz");
                    for (let i = 0; i < ecoz250.length; i++) {
                        for (let j = 0; j < exhaustecoz250.length; j++) {
                            if (ecoz250[i].ProductColorCode === exhaustecoz250[j].color) {
                                exhaustecoz250[j].available = true;
                            }
                        }
                    }
                    setexhaustactiveecoz250(ecoz250[0]);
                    setExhaustFanDataEcoz250(ecoz250);

                    const turbo150 = response.data.filter((item) => item.ProductSize === "150mm" && item.ProductCategory === "ecoz_turbo");
                    for (let i = 0; i < turbo150.length; i++) {
                        for (let j = 0; j < exhausturbo150.length; j++) {
                            if (turbo150[i].ProductColorCode === exhausturbo150[j].color) {
                                exhausturbo150[j].available = true;
                            }
                        }
                    }
                    setexhaustactiveturbo150(turbo150[0]);
                    setExhaustFanDataTurbo150(turbo150);

                    const turbo200 = response.data.filter((item) => item.ProductSize === "200mm" && item.ProductCategory === "ecoz_turbo");
                    for (let i = 0; i < turbo200.length; i++) {
                        for (let j = 0; j < exhausturbo200.length; j++) {
                            if (turbo200[i].ProductColorCode === exhausturbo200[j].color) {
                                exhausturbo200[j].available = true;
                            }
                        }
                    }
                    setexhaustactiveturbo200(turbo200[0]);
                    setExhaustFanDataTurbo200(turbo200);

                    const turbo250 = response.data.filter((item) => item.ProductSize === "250mm" && item.ProductCategory === "ecoz_turbo");

                    for (let i = 0; i < turbo250.length; i++) {
                        for (let j = 0; j < exhausturbo250.length; j++) {
                            if (turbo250[i].ProductColorCode === exhausturbo250[j].color) {
                                exhausturbo250[j].available = true;
                            }
                        }
                    }
                    setexhaustactiveturbo250(turbo250[0]);
                    setExhaustFanDataTurbo250(turbo250);










                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    const updateProduct = (color, type, size) => {
        if (type === "ecoz" && size === "150mm") {
            const activeProduct = exhaustFanDataEcoz150.find(product => product.ProductColorCode === color && product.ProductSize === size && product.ProductCategory === type);
            setexhaustactiveecoz150(activeProduct);
        }
        if (type === "ecoz" && size === "200mm") {
            const activeProduct = exhaustFanDataEcoz200.find(product => product.ProductColorCode === color && product.ProductSize === size && product.ProductCategory === type);
            setexhaustactiveecoz200(activeProduct);
        }
        if (type === "ecoz" && size === "250mm") {
            const activeProduct = exhaustFanDataEcoz250.find(product => product.ProductColorCode === color && product.ProductSize === size && product.ProductCategory === type);
            setexhaustactiveecoz250(activeProduct);
        }
        if (type === "ecoz_turbo" && size === "150mm") {
            const activeProduct = exhaustFanDataTurbo150.find(product => product.ProductColorCode === color && product.ProductSize === size && product.ProductCategory === type);
            setexhaustactiveturbo150(activeProduct);
        }
        if (type === "ecoz_turbo" && size === "200mm") {
            const activeProduct = exhaustFanDataTurbo200.find(product => product.ProductColorCode === color && product.ProductSize === size && product.ProductCategory === type);
            setexhaustactiveturbo200(activeProduct);
        }
        if (type === "ecoz_turbo" && size === "250mm") {
            const activeProduct = exhaustFanDataTurbo250.find(product => product.ProductColorCode === color && product.ProductSize === size && product.ProductCategory === type);
            setexhaustactiveturbo250(activeProduct);
        }

    }


    const getClickedProduct = (data) => {
        localStorage.setItem("exhaust_type", data?.ProductCategory)
        localStorage.setItem("exhaust_color", data?.ProductColorCode)
        localStorage.setItem("exhaust_size", data?.ProductSize)
    }



    const getActiveColorName = (colorcode, type, size) => {
        if (type === "ecoz" && size === "150mm") {
            const activeColorObject = exhaustecoz150.find(color => color.color === colorcode);
            return activeColorObject ? activeColorObject.value : "";
        }
        if (type === "ecoz" && size === "200mm") {
            const activeColorObject = exhaustecoz200.find(color => color.color === colorcode);
            return activeColorObject ? activeColorObject.value : "";
        }

        if (type === "ecoz" && size === "250mm") {
            const activeColorObject = exhaustecoz250.find(color => color.color === colorcode);
            return activeColorObject ? activeColorObject.value : "";
        }

        if (type === "ecoz_turbo" && size === "150mm") {
            const activeColorObject = exhausturbo150.find(color => color.color === colorcode);
            return activeColorObject ? activeColorObject.value : "";
        }
        if (type === "ecoz_turbo" && size === "200mm") {
            const activeColorObject = exhausturbo200.find(color => color.color === colorcode);
            return activeColorObject ? activeColorObject.value : "";
        }

        if (type === "ecoz_turbo" && size === "250mm") {
            const activeColorObject = exhausturbo250.find(color => color.color === colorcode);
            return activeColorObject ? activeColorObject.value : "";
        }
    };

    const [webImage, setWebImage] = useState([])
    const [mobImage, setMobImage] = useState([])
    const [faq, setFaq] = useState([])
    const [editorContent, setEditorContent] = useState("")

    const fetchWebData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCMSProductCategory/categoryexhaust007`);
            if (response.ok) {
                const result = await response.json();
                setFaq(result.data.faqs)
                setEditorContent(result.data.editorContent)
                const webImage = result.data.banners.filter((item) => !item.imgSrc.includes("mob"))
                const mobImage = result.data.banners.filter((item) => !item.imgSrc.includes("mob"))
                setWebImage(webImage)
                setMobImage(mobImage)
            }
        } catch (error) {
            console.log(error)
        }

    };
    const [showMore, setShowMore] = useState(false)
    const [showMore1, setShowMore1] = useState(false)
    const [isH3Visible, setIsH3Visible] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const h3Ref3 = useRef(null);
    useEffect(() => {


        const title3 = h3Ref3.current;

        if (title3) {
            const rect3 = title3.getBoundingClientRect();
            const offset3 = window.innerHeight / 2;

            if (rect3.top <= offset3) {
                title3.classList.add('active');
            } else {
                // title3.classList.remove('active');
            }
        }
    }, [scrollPosition]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const h3Position = h3Ref3?.current?.offsetTop;
            const offset = window.innerHeight / 2;

            if (scrollPosition + offset >= h3Position) {
                setTimeout(() => {
                    setIsH3Visible(true);
                }, 500);
            } else {
                //   setIsH3Visible(false);
            }


            setScrollPosition(scrollPosition);
        };

        window.addEventListener('scroll', handleScroll);
        fetchWebData()
        getproduct()
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);





    return (
        <section className="mt-5 pt-4">

            <ExhaustHead />

            {webImage.length > 0 || mobImage.length > 0 ? <ProductCarousel webImages={webImage} mobImages={mobImage} /> : ""}

            <div className="container-fluid p-4 ">
                <div className="row mt-5 mb-5 exhaust-margin-category">
                    <div className="col-md-12 ">
                        <h1 className={`border-bottom-animation h3hoverbefore ${isH3Visible ? 'active' : ''}`} ref={h3Ref3} style={{
                            textAlign: "left"
                        }}>BLDC Exhaust Fan</h1>


                    </div>









                    {exhaustactiveecoz150 ?
                        <div className="col-md-3 " key={0}>
                            <div className="bg-w">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <NavLink to={`/exhaust-fan-${exhaustactiveecoz150.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}>
                                            <div className="pro-img" onClick={() => {
                                                getClickedProduct(exhaustactiveecoz150)
                                            }}>
                                                <LazyLoadImage
                                                    src={exhaustactiveecoz150.Productthumbnail}
                                                    className="img-fluid blade-img lazyimg helix100 accessimg"
                                                    alt={exhaustactiveecoz150.ProductName}
                                                    effect="blur"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-12" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                        <div className="box-txt" style={{ paddingTop: "3px" }}>
                                            <h5 style={{ fontWeight: 500 }}>{exhaustactiveecoz150.ProductName}</h5>
                                            <div className="helixcolorlist">
                                                {exhaustecoz150.map((item, index) => (
                                                    item.available ? (
                                                        <div
                                                            className={item.color === exhaustactiveecoz150.ProductColorCode ? "clr1 listactive helixcolorlistitem helixcoloractive" : "clr1 helixcolorlistitem"}
                                                            key={index}
                                                            data-hover={getActiveColorName(item.color, "ecoz", "150mm")}
                                                            onClick={() => updateProduct(item.color, "ecoz", "150mm")}
                                                            style={{
                                                                padding: "10px",
                                                                transform: "rotate(90deg)",
                                                                background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                                pointerEvents: item.available ? "auto" : "none",
                                                            }}
                                                        >
                                                            <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}></div>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>

                                            <p className=" ">Sweep Size:</p>
                                            <div className="text-center">

                                                <button
                                                    className={"exhaust-sweep-btn exhaust-sweep-btnactive"}


                                                >
                                                    {exhaustactiveecoz150.ProductSize}
                                                </button>

                                            </div>

                                            <div className="price-btn ">
                                                <div className="price">
                                                    <p><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveecoz150.ProductSelling} <span>-{((((exhaustactiveecoz150.ProductPrice - exhaustactiveecoz150.ProductSelling) / exhaustactiveecoz150.ProductPrice)) * 100)?.toFixed(0)}%</span></p>
                                                    <p className="dis"><del><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveecoz150.ProductPrice}</del></p>
                                                </div>
                                                <NavLink to={`/exhaust-fan-${exhaustactiveecoz150.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}><div className="buy-btn"><button className="btn" onClick={() => {
                                                    getClickedProduct(exhaustactiveecoz150)
                                                }}>Buy Now</button></div></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}
                    {exhaustactiveturbo150 ?
                        <div className="col-md-3 " key={1}>
                            <div className="bg-w">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <NavLink to={`/exhaust-fan-${exhaustactiveturbo150.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}>
                                            <div className="pro-img" onClick={() => {
                                                getClickedProduct(exhaustactiveturbo150)
                                            }}>
                                                <LazyLoadImage
                                                    src={exhaustactiveturbo150.Productthumbnail}
                                                    className="img-fluid blade-img lazyimg helix100 accessimg"
                                                    alt={exhaustactiveturbo150.ProductName}
                                                    effect="blur"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-12" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                        <div className="box-txt" style={{ paddingTop: "3px" }}>
                                            <h5 style={{ fontWeight: 500 }}>{exhaustactiveturbo150.ProductName}</h5>
                                            <div className="helixcolorlist">
                                                {exhausturbo150.map((item, index) => (
                                                    item.available ? (
                                                        <div
                                                            className={item.color === exhaustactiveturbo150.ProductColorCode ? "clr1 listactive helixcolorlistitem helixcoloractive" : "clr1 helixcolorlistitem"}
                                                            key={index}
                                                            data-hover={getActiveColorName(item.color, "ecoz_turbo", "150mm")}
                                                            onClick={() => updateProduct(item.color, "ecoz_turbo", "150mm")}
                                                            style={{
                                                                padding: "10px",
                                                                transform: "rotate(90deg)",
                                                                background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                                pointerEvents: item.available ? "auto" : "none",
                                                            }}
                                                        >
                                                            <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}></div>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>

                                            <p className=" ">Sweep Size:</p>
                                            <div className="text-center">

                                                <button
                                                    className={"exhaust-sweep-btn exhaust-sweep-btnactive"}


                                                >
                                                    {exhaustactiveturbo150.ProductSize}
                                                </button>

                                            </div>

                                            <div className="price-btn ">
                                                <div className="price">
                                                    <p><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveturbo150.ProductSelling} <span>-{((((exhaustactiveturbo150.ProductPrice - exhaustactiveturbo150.ProductSelling) / exhaustactiveturbo150.ProductPrice)) * 100)?.toFixed(0)}%</span></p>
                                                    <p className="dis"><del><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveturbo150.ProductPrice}</del></p>
                                                </div>
                                                <NavLink to={`/exhaust-fan-${exhaustactiveturbo150.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}><div className="buy-btn"><button className="btn" onClick={() => {
                                                    getClickedProduct(exhaustactiveturbo150)
                                                }}>Buy Now</button></div></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}









                    {/* {exhaustactiveecoz200 || exhaustactiveturbo200 ? <div className="row justify-content-center">
                    <div className="col-md-11 ">
                        <h2 className={`border-bottom-animation h3hoverbefore ${isH3Visible ? 'active' : ''}`} ref={h3Ref3} style={{
                            textAlign: "left"
                        }}>200mm Exhaust Fan</h2>


                    </div> */}









                    {exhaustactiveecoz200 ?
                        <div className="col-md-3 " key={2}>
                            <div className="bg-w">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <NavLink to={`/exhaust-fan-${exhaustactiveecoz200.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}>
                                            <div className="pro-img" onClick={() => {
                                                getClickedProduct(exhaustactiveecoz200)
                                            }}>
                                                <LazyLoadImage
                                                    src={exhaustactiveecoz200.Productthumbnail}
                                                    className="img-fluid blade-img lazyimg helix100 accessimg"
                                                    alt={exhaustactiveecoz200.ProductName}
                                                    effect="blur"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-12" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                        <div className="box-txt" style={{ paddingTop: "3px" }}>
                                            <h5 style={{ fontWeight: 500 }}>{exhaustactiveecoz200.ProductName}</h5>
                                            <div className="helixcolorlist">
                                                {exhaustecoz200.map((item, index) => (
                                                    item.available ? (
                                                        <div
                                                            className={item.color === exhaustactiveecoz200.ProductColorCode ? "clr1 listactive helixcolorlistitem helixcoloractive" : "clr1 helixcolorlistitem"}
                                                            key={index}
                                                            data-hover={getActiveColorName(item.color, "ecoz", "200mm")}
                                                            onClick={() => updateProduct(item.color, "ecoz", "200mm")}
                                                            style={{
                                                                padding: "10px",
                                                                transform: "rotate(90deg)",
                                                                background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                                pointerEvents: item.available ? "auto" : "none",
                                                            }}
                                                        >
                                                            <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}></div>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>

                                            <p className=" ">Sweep Size:</p>
                                            <div className="text-center">

                                                <button
                                                    className={"exhaust-sweep-btn exhaust-sweep-btnactive"}


                                                >
                                                    {exhaustactiveecoz200.ProductSize}
                                                </button>

                                            </div>

                                            <div className="price-btn ">
                                                <div className="price">
                                                    <p><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveecoz200.ProductSelling} <span>-{((((exhaustactiveecoz200.ProductPrice - exhaustactiveecoz200.ProductSelling) / exhaustactiveecoz200.ProductPrice)) * 100)?.toFixed(0)}%</span></p>
                                                    <p className="dis"><del><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveecoz200.ProductPrice}</del></p>
                                                </div>
                                                <NavLink to={`/exhaust-fan-${exhaustactiveecoz200.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}><div className="buy-btn"><button className="btn" onClick={() => {
                                                    getClickedProduct(exhaustactiveecoz200)
                                                }}>Buy Now</button></div></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}
                    {exhaustactiveturbo200 ?

                        <div className="col-md-3 " key={3}>
                            <div className="bg-w">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <NavLink to={`/exhaust-fan-${exhaustactiveturbo200.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}>
                                            <div className="pro-img" onClick={() => {
                                                getClickedProduct(exhaustactiveturbo200)
                                            }}>
                                                <LazyLoadImage
                                                    src={exhaustactiveturbo200.Productthumbnail}
                                                    className="img-fluid blade-img lazyimg helix100 accessimg"
                                                    alt={exhaustactiveturbo200.ProductName}
                                                    effect="blur"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-12" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                        <div className="box-txt" style={{ paddingTop: "3px" }}>
                                            <h5 style={{ fontWeight: 500 }}>{exhaustactiveturbo200.ProductName}</h5>
                                            <div className="helixcolorlist">
                                                {exhausturbo200.map((item, index) => (
                                                    item.available ? (
                                                        <div
                                                            className={item.color === exhaustactiveturbo200.ProductColorCode ? "clr1 listactive helixcolorlistitem helixcoloractive" : "clr1 helixcolorlistitem"}
                                                            key={index}
                                                            data-hover={getActiveColorName(item.color, "ecoz_turbo", "200mm")}
                                                            onClick={() => updateProduct(item.color, "ecoz_turbo", "200mm")}
                                                            style={{
                                                                padding: "10px",
                                                                transform: "rotate(90deg)",
                                                                background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                                pointerEvents: item.available ? "auto" : "none",
                                                            }}
                                                        >
                                                            <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}></div>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>

                                            <p className=" ">Sweep Size:</p>
                                            <div className="text-center">

                                                <button
                                                    className={"exhaust-sweep-btn exhaust-sweep-btnactive"}


                                                >
                                                    {exhaustactiveturbo200.ProductSize}
                                                </button>

                                            </div>

                                            <div className="price-btn ">
                                                <div className="price">
                                                    <p><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveturbo200.ProductSelling} <span>-{((((exhaustactiveturbo200.ProductPrice - exhaustactiveturbo200.ProductSelling) / exhaustactiveturbo200.ProductPrice)) * 100)?.toFixed(0)}%</span></p>
                                                    <p className="dis"><del><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveturbo200.ProductPrice}</del></p>
                                                </div>
                                                <NavLink to={`/exhaust-fan-${exhaustactiveturbo200.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}><div className="buy-btn"><button className="btn" onClick={() => {
                                                    getClickedProduct(exhaustactiveturbo200)
                                                }}>Buy Now</button></div></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}







                    {/* </div> : ""} */}
                    {/* {exhaustactiveecoz250 || exhaustactiveturbo250 ? <div className="row justify-content-center">
                    <div className="col-md-11 ">
                        <h2 className={`border-bottom-animation h3hoverbefore ${isH3Visible ? 'active' : ''}`} ref={h3Ref3} style={{
                            textAlign: "left"
                        }}>250mm Exhaust Fan</h2>


                    </div> */}









                    {exhaustactiveecoz250 ?
                        <div className="col-md-3 " key={4}>
                            <div className="bg-w">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <NavLink to={`/exhaust-fan-${exhaustactiveecoz250.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}>
                                            <div className="pro-img" onClick={() => {
                                                getClickedProduct(exhaustactiveecoz250)
                                            }}>
                                                <LazyLoadImage
                                                    src={exhaustactiveecoz250.Productthumbnail}
                                                    className="img-fluid blade-img lazyimg helix100 accessimg"
                                                    alt={exhaustactiveecoz250.ProductName}
                                                    effect="blur"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-12" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                        <div className="box-txt" style={{ paddingTop: "3px" }}>
                                            <h5 style={{ fontWeight: 500 }}>{exhaustactiveecoz250.ProductName}</h5>
                                            <div className="helixcolorlist">
                                                {exhaustecoz250.map((item, index) => (
                                                    item.available ? (
                                                        <div
                                                            className={item.color === exhaustactiveecoz250.ProductColorCode ? "clr1 listactive helixcolorlistitem helixcoloractive" : "clr1 helixcolorlistitem"}
                                                            key={index}
                                                            data-hover={getActiveColorName(item.color, "ecoz", "250mm")}
                                                            onClick={() => updateProduct(item.color, "ecoz", "250mm")}
                                                            style={{
                                                                padding: "10px",
                                                                transform: "rotate(90deg)",
                                                                background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                                pointerEvents: item.available ? "auto" : "none",
                                                            }}
                                                        >
                                                            <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}></div>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>

                                            <p className=" ">Sweep Size:</p>
                                            <div className="text-center">

                                                <button
                                                    className={"exhaust-sweep-btn exhaust-sweep-btnactive"}


                                                >
                                                    {exhaustactiveecoz250.ProductSize}
                                                </button>

                                            </div>

                                            <div className="price-btn ">
                                                <div className="price">
                                                    <p><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveecoz250.ProductSelling} <span>-{((((exhaustactiveecoz250.ProductPrice - exhaustactiveecoz250.ProductSelling) / exhaustactiveecoz250.ProductPrice)) * 100)?.toFixed(0)}%</span></p>
                                                    <p className="dis"><del><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveecoz250.ProductPrice}</del></p>
                                                </div>
                                                <NavLink to={`/exhaust-fan-${exhaustactiveecoz250.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}><div className="buy-btn"><button className="btn" onClick={() => {
                                                    getClickedProduct(exhaustactiveecoz250)
                                                }}>Buy Now</button></div></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}
                    {exhaustactiveturbo250 ?

                        <div className="col-md-3 " key={5}>
                            <div className="bg-w">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <NavLink to={`/exhaust-fan-${exhaustactiveturbo250.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}>
                                            <div className="pro-img" onClick={() => {
                                                getClickedProduct(exhaustactiveturbo250)
                                            }}>
                                                <LazyLoadImage
                                                    src={exhaustactiveturbo250.Productthumbnail}
                                                    className="img-fluid blade-img lazyimg helix100 accessimg"
                                                    alt={exhaustactiveturbo250.ProductName}
                                                    effect="blur"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="col-lg-12" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                        <div className="box-txt" style={{ paddingTop: "3px" }}>
                                            <h5 style={{ fontWeight: 500 }}>{exhaustactiveturbo250.ProductName}</h5>
                                            <div className="helixcolorlist">
                                                {exhausturbo250.map((item, index) => (
                                                    item.available ? (
                                                        <div
                                                            className={item.color === exhaustactiveturbo250.ProductColorCode ? "clr1 listactive helixcolorlistitem helixcoloractive" : "clr1 helixcolorlistitem"}
                                                            key={index}
                                                            data-hover={getActiveColorName(item.color, "ecoz_turbo", "250mm")}
                                                            onClick={() => updateProduct(item.color, "ecoz_turbo", "250mm")}
                                                            style={{
                                                                padding: "10px",
                                                                transform: "rotate(90deg)",
                                                                background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                                pointerEvents: item.available ? "auto" : "none",
                                                            }}
                                                        >
                                                            <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}></div>
                                                        </div>
                                                    ) : null
                                                ))}
                                            </div>

                                            <p className=" ">Sweep Size:</p>
                                            <div className="text-center">

                                                <button
                                                    className={"exhaust-sweep-btn exhaust-sweep-btnactive"}


                                                >
                                                    {exhaustactiveturbo250.ProductSize}
                                                </button>

                                            </div>

                                            <div className="price-btn ">
                                                <div className="price">
                                                    <p><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveturbo250.ProductSelling} <span>-{((((exhaustactiveturbo250.ProductPrice - exhaustactiveturbo250.ProductSelling) / exhaustactiveturbo250.ProductPrice)) * 100)?.toFixed(0)}%</span></p>
                                                    <p className="dis"><del><i className="fa fa-inr" aria-hidden="true"></i>{exhaustactiveturbo250.ProductPrice}</del></p>
                                                </div>
                                                <NavLink to={`/exhaust-fan-${exhaustactiveturbo250.ProductCategory === "ecoz" ? "ecoz" : "turbo"}`}><div className="buy-btn"><button className="btn" onClick={() => {
                                                    getClickedProduct(exhaustactiveturbo250)
                                                }}>Buy Now</button></div></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}

                </div>

                <div className="row justify-content-center  mt-5 mb-5">
                    <div className="col-md-12">
                        <div className="borderRound" >
                            <div id="">
                                <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/video+create+banner.png"}
                                    width={"100%"}
                                    // height={"500px"}

                                    // width={"190vw"}
                                    // Width={window.innerWidth < 780 ?"50vw":"10vw"}
                                    // {window.innerWidth < 780 ?   width={"100vw"}: ""} 
                                    // className="d-block w-100 img-fluid acess-banner" alt="..."
                                    effect="blur" alt="Energy Efficient Exhaust Fan"
                                />
                            </div>

                            {/* <div id="">
                                <ReactPlayer
                                    url={"https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/exhaustvid1.mp4"}
                                    width={"100%"}
                                    height={"500px"}
                                    controls={true}
                                />
                            </div> */}
                        </div>
                    </div>



                </div>
                <div className="row justify-content-center  mt-5 mb-5">
                    <div className="col-md-4">
                        <div className="borderRound" >
                            <div id="">
                                <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/exhaust-cat-banner1.png"}
                                    width={"100%"}
                                    // height={"500px"}

                                    // width={"190vw"}
                                    // Width={window.innerWidth < 780 ?"50vw":"10vw"}
                                    // {window.innerWidth < 780 ?   width={"100vw"}: ""} 
                                    // className="d-block w-100 img-fluid acess-banner" alt="..."
                                    effect="blur" alt="Energy Efficient Exhaust Fan"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="borderRound" >
                            <div id="">
                                <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/exhaust-cat-banner2.png"}
                                    width={"100%"}
                                    // height={"500px"}

                                    // width={"190vw"}
                                    // Width={window.innerWidth < 780 ?"50vw":"10vw"}
                                    // {window.innerWidth < 780 ?   width={"100vw"}: ""} 
                                    // className="d-block w-100 img-fluid acess-banner" alt="..."
                                    effect="blur" alt="Exhaust Fans"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="borderRound" >
                            <div id="">
                                <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/exhaust-cat-banner3.png"}
                                    width={"100%"}
                                    // height={"500px"}

                                    // width={"190vw"}
                                    // Width={window.innerWidth < 780 ?"50vw":"10vw"}
                                    // {window.innerWidth < 780 ?   width={"100vw"}: ""} 
                                    // className="d-block w-100 img-fluid acess-banner" alt="..."
                                    effect="blur" alt="BLDC Exhaust Fans"
                                />
                            </div>
                        </div>
                    </div>
                </div>


                {/* 
                </div> : ""} */}




            </div>
            <div className=" pt-4 pb-4" style={{ backgroundColor: "#F5F7FA" }}>
                <div className="container" >
                    <FadeInSection>
                        <div className="row mt-5 mb-5">
                            <div className="col-md-6 below-txt-fnt-style">
                                <div
                                    className={`content-wrapper ${showMore ? "expanded" : "collapsed"}`}
                                    dangerouslySetInnerHTML={{ __html: editorContent?.toString() }}
                                ></div>

                                <p className="text-center mt-4">
                                    <button
                                        className="btn view"
                                        onClick={() => {
                                            setShowMore(!showMore);
                                        }}
                                    >
                                        {showMore ? "View Less" : "View More"}
                                    </button>
                                </p>
                            </div>

                            <div className="col-md-6">
                                <div className="accordion accordion-flush" id="accordionFlushExample">

                                    <h2 className="faq-head-product">Frequently Asked Questions</h2>
                                    <ProductFaq faqs={faq} />
                                </div>
                                {/* <p className="text-center mt-4"><NavLink to=""><button className="btn view">View More</button></NavLink></p> */}
                                <br />
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

        </section>

    );
}
export default Exhaust;